import React from "react"

export const SvgFile = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0366 18.975H17.043C17.1911 18.975 17.3236 18.9401 17.4388 18.8758C17.4577 18.8652 17.4727 18.8496 17.4907 18.8377C17.5275 18.8128 17.5652 18.7894 17.5985 18.7584C17.6452 18.7139 17.6875 18.663 17.7259 18.6073C17.7275 18.6048 17.7297 18.6032 17.7316 18.6006C17.8907 18.366 17.9758 18.0361 17.9755 17.656C17.9755 16.9587 17.6468 16.3593 17.042 16.3593C16.8103 16.3593 16.6187 16.4464 16.4689 16.5932C16.2279 16.8304 16.0977 17.2249 16.0977 17.6726C16.0977 18.4044 16.4491 18.975 17.0366 18.975Z"
      fill="#00AEEF"
    />
    <path
      d="M20.7669 6.39646V1.59998H6.43631C6.02271 1.60006 5.62609 1.76442 5.33366 2.05691C5.04123 2.3494 4.87695 2.74606 4.87695 3.15966V28.8403C4.87703 29.2539 5.04134 29.6505 5.33375 29.943C5.62616 30.2355 6.02274 30.3998 6.43631 30.4H25.563C25.9767 30.3998 26.3733 30.2355 26.6658 29.943C26.9584 29.6505 27.1228 29.2539 27.123 28.8403V7.95612H22.3266C21.9129 7.95612 21.5162 7.79178 21.2237 7.49932C20.9312 7.20685 20.7669 6.81012 20.7669 6.39646Z"
      fill="#FF4E50"
    />
    <path
      d="M16.1286 21.291L15.8128 21.5761C14.9406 22.3635 13.5264 22.3634 12.6542 21.5761C11.7819 20.7888 11.7819 19.5123 12.6542 18.725L13.4074 18.045C14.2125 17.3183 15.5179 17.3183 16.323 18.045L16.4445 18.1547M15.8714 16.0422L16.1873 15.7572C17.0595 14.9698 18.4736 14.9698 19.3459 15.7572C20.2181 16.5445 20.2181 17.821 19.3459 18.6083L18.5927 19.2882C17.7876 20.015 16.4822 20.015 15.6771 19.2882L15.5556 19.1786"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g opacity="0.6">
      <path
        d="M20.7676 1.59998V6.39646C20.7676 6.81005 20.9319 7.20672 21.2243 7.49918C21.5167 7.79172 21.9134 7.95605 22.327 7.95612H27.1238L20.7676 1.59998Z"
        fill="#99DFF9"
      />
      <path
        d="M20.7676 1.59998V6.39646C20.7676 6.81005 20.9319 7.20672 21.2243 7.49918C21.5167 7.79172 21.9134 7.95605 22.327 7.95612H27.1238L20.7676 1.59998Z"
        fill="#FF4E50"
      />
    </g>
  </svg>
)
